/**
 * Route config
 */

const ROUTES = {
  HOME: '/',
  ERROR: '/error',
  LOGIN: '/login',
  USER_INFO: '/userinfo',
  DIGITAL_SURVEY: '/digital-survey',
  AUDIO_ANALYSIS: '/audio-analysis',
  EDIT_SYSTEMS: '/users/:user_id/services',
  PEOPLE_MEASUREMENT: '/people-measurement',
  SETTING_CONTENT_SYSTEM: '/setting-content-system/:service_id',
  SYSTEM_APPLICATION_SETTING: '/system-application-setting',
  SYSTEM_APPLICATION_STATUS_CHECK: '/system-application-status-check',
  NOT_FOUND: '*',
};

export default ROUTES;
